export default __webpack_public_path__ + "1abfef97a36811e796a46aafecef5e3d.svg";